module.exports = __webpack_public_path__ + "img/fruits-welcome.679c3a86.png";